﻿import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import AuditHistoryComponent from './AuditHistoryComponent';
import { BenchSheetTechnologyType, Entities, ReportType } from '../models/enums';

import { Button } from 'devextreme-react/button'
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    batchId: string;
    entity: Entities;
    auditRowPointer?: string;
    technologyId?: BenchSheetTechnologyType;
    documentationId?: number;
    title: string;
    subtitle?: string;
    leftInfo?: string;
    leftInfoSubtitle?: string;
    rightInfo?: string;
    rightInfoSubtitle?: string;
    auditShowOtherIdColumn?: boolean;
    auditChildData?: boolean;
    showPrintButton?: boolean;
    showItemInformation?: () => void;
    showTicketLog?: () => void;
}

export default function BatchPlanningToolbar(props: Props) {
    //const [issuesFound, setIssuesFound] =
    //    useState<boolean>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    return (
        <div>
            <div className="lq-title-bar">
                <div>
                    <div className="lq-main-title">{props.title}</div>
                    {props.subtitle &&
                        <div className="lq-header-subtitle">{props.subtitle}</div>
                    }
                </div>

                <div className="toolbar-right-container">

                    {props.leftInfo &&
                        <div className="toolbar-info-block">
                            <div className="lq-header-label">{props.leftInfo}</div>
                            <div className="lq-header-3 pw-blue">{props.leftInfoSubtitle}</div>
                        </div>
                    }

                    {props.rightInfo &&
                        <div className="toolbar-info-block">
                            <div className="lq-header-label">{props.rightInfo}</div>
                            <div className="lq-header-3 pw-blue">{props.rightInfoSubtitle}</div>
                        </div>
                    }

                    <div className="save-toolbar">

                        {/* TODO:
                    {issuesFound &&
                        <div>
                            <Button className="title-bar-button pw-bg-rr-400"
                                text="" icon="warning" type="danger"
                                hint="issues found"
                                onClick={showIssuesDialog} />
                        </div>
                    }
                    */}

                        <div>
                            <Button className="title-bar-button pw-bg-rp-400"
                                text="" icon="tel" type="normal"
                                hint="report issue"
                                onClick={showTicketLog} />
                        </div>
                        {props.technologyId &&
                            <div>
                                <Button className="title-bar-button pw-bg-vc-400"
                                    text="" icon="export" type="normal"
                                    hint="apply to another batch"
                                    onClick={applyToBatch} />
                            </div>
                        }
                        {props.auditRowPointer &&
                            <div>
                                <Button className="title-bar-button pw-bg-rb-400"
                                    text="" icon="clock" type="normal"
                                    hint="auditing information"
                                    onClick={showAuditInformationDialog} />
                            </div>
                        }
                        {props.documentationId &&
                            <div>
                                <NavLink to={`/documentation/${props.documentationId}`}
                                    className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                    <Button className="title-bar-button pw-bg-rg-400"
                                        text="" icon="help" type="normal"
                                        hint="help and documentation" />
                                </NavLink>
                            </div>
                        }
                        <div>
                            <Button className="title-bar-button pw-bg-vy-400"
                                text="" icon="info" type="normal"
                                hint="item information"
                                onClick={showItemInformation} />
                        </div>

                        {props.showPrintButton &&
                            <div>
                                <NavLink to={`/print-batch-planning/${props.batchId}`}
                                    className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                    <Button className="title-bar-button pw-bg-rg-400"
                                        text="" icon="print" type="normal"
                                        hint="print" />
                                </NavLink>
                            </div>
                        }

                        <div>
                            <Button className="title-bar-button pw-bg-neutral-400"
                                id="goBackButton" text="" icon="arrowleft" type="normal"
                                hint="go back"
                                onClick={goBack} />
                        </div>
                    </div>
                </div>

                {auditInformationDialogVisible &&
                    <DialogPopup visible={auditInformationDialogVisible}
                        onHiding={hideAuditInformationDialog}
                        title="Audit History"
                        width='75vw'
                        height='75vh'
                        dragEnabled={true}
                        hideOnOutsideClick={false}
                        resizeEnabled={false}>
                        <AuditHistoryComponent entityNumber={props.entity}
                            technology={props.technologyId ? props.technologyId : undefined}
                            key={`AuditHistory${key}`}
                            showOtherIdColumn={props.auditShowOtherIdColumn}
                            childData={props.auditChildData}
                            rowPointer={props.auditRowPointer} />
                    </DialogPopup>
                }

            </div>
        </div>
    );

    function applyToBatch() {


    }

    //navigation

    function goBack() {
        history.back();
    }

    // show/hide
    async function showAuditInformationDialog() {
        setAuditInformationDialogVisible(true);
    }

    function hideAuditInformationDialog() {
        setAuditInformationDialogVisible(false);
    }

    function showTicketLog() {
        if (props.showTicketLog)
            props.showTicketLog();
    }

    function showItemInformation() {
        if (props.showItemInformation)
            props.showItemInformation();
    }
}